<div class="cipo">
    @if (options().toolbarInline) {
        @if (!(fieldData()?.readonly === true)) {
            <mat-form-field
                class="cipo--width--full cipo-froala"
                appearance="outline"
                floatLabel="always"
                [ngClass]="{
                    'cipo-mark-changed': fieldData().markChanged && valueChanged(),
                }"
                (click)="focusEditor()">
                @if (fieldData()?.label) {
                    <mat-label>{{ fieldData()?.label | translate }}</mat-label>
                }
                <textarea matInput [froalaEditor]="options()" [formControl]="control()"></textarea>
                <mat-hint>
                    @if (fieldData()?.hint) {
                        {{ fieldData().hint | translate }}
                    }
                </mat-hint>
                @if (control()?.touched && control()?.invalid) {
                    <mat-error>
                        @if (control()?.hasError("required")) {
                            {{ "errors.required" | translate }}
                        } @else if (control()?.hasError("custom")) {
                            {{ control()?.errors?.["custom"] | translate }}
                        } @else {
                            {{ "errors.unknownError" | translate }}
                        }
                    </mat-error>
                }
                @if (fieldData().fieldDescription) {
                    <mat-icon
                        matSuffix
                        data-testid="cipo-text-input-info"
                        class="material-icons-outlined cipo--cursor--help"
                        [title]="fieldData().fieldDescription | translate">
                        info
                    </mat-icon>
                }
            </mat-form-field>
        } @else {
            <cipo-outline-field [label]="fieldData()?.label">
                <div
                    class="cipo--height-max--half-screen cipo--width--full"
                    [class.p-t-md]="!fieldData().hint"
                    fxLayout
                    fxLayoutAlign="space-between center">
                    <div [froalaView]="content() ?? ''" class="view-mode"></div>
                </div>
            </cipo-outline-field>
        }
    } @else {
        @let invalid = control() ? control().invalid && (control().touched || control().dirty) : false;
        @if (fieldData()?.label) {
            <p class="cipo-mat-label-size" [ngClass]="{ 'cipo-text--warn-700': invalid }">
                {{ fieldData().label | translate }}
                @if (fieldData().required && fieldData().readonly === false) {
                    <span class="cipo-text--warn-700">*</span>
                }
            </p>
        }
        @if (!(fieldData()?.readonly === true)) {
            <div class="cipo-froala" [ngClass]="{ error: invalid }">
                <textarea [froalaEditor]="options()" [(froalaModel)]="content" required></textarea>
                @if (fieldData()?.hint) {
                    <p class="m-b-0">{{ fieldData().hint }}</p>
                }
                @if (tributeOptions().variables) {
                    <p class="text-size--label">{{ "FROALA.variablesHint" | translate }}</p>
                }
                @if (tributeOptions().mentions) {
                    <p class="text-size--label">{{ "FROALA.mentionsHint" | translate }}</p>
                }
                @if (invalid) {
                    <p class="text-size--label error">{{ "FROALA.required" | translate }}</p>
                }
            </div>
        } @else {
            <div [froalaView]="content() ?? ''" class="view-mode"></div>
        }
    }
</div>
